import React, { useContext, useState, useEffect, useCallback } from 'react'
import { motion, AnimatePresence } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../Context/DataContext'
import { UIContext } from '../../Context/UIContext'

import MenuButton from './MenuButton'
import HomeLink from '../HomeLink'

const Topbar = ({ isLight }) => {
    const { strings } = useContext(DataContext)
    const { isMobile, currentPage, setCurrentPage, setMemberModalVisible, menuOpen, memberModalVisible, memberModalRef, modalVisible } = useContext(UIContext)
    const [showTopbar, setShowTopbar] = useState(false)
    const [isFixed, setIsFixed] = useState(false)
    const showMinimal = isMobile === true

    const handleScrollWindow = useCallback(() => {
        setIsFixed(window.scrollY > 0)
    }, [])

    const handleScrollModal = useCallback(() => {
        if (memberModalRef && memberModalRef.current) {
            setIsFixed(memberModalRef.current.scrollTop > 0)
        }
    }, [memberModalRef])    

    const handleExit = useCallback(() => {
        setMemberModalVisible(false)
        setCurrentPage('team-partners')
    }, [setCurrentPage, setMemberModalVisible])

    useEffect(() => {
        const currentModalRef = memberModalRef?.current
    
        if (memberModalVisible && currentModalRef) {
            window.removeEventListener("scroll", handleScrollWindow)
            currentModalRef.addEventListener("scroll", handleScrollModal)
        } else {
            currentModalRef && currentModalRef.removeEventListener("scroll", handleScrollModal)
            window.addEventListener("scroll", handleScrollWindow)
        }
    
        return () => {
            window.removeEventListener("scroll", handleScrollWindow)
            currentModalRef && currentModalRef.removeEventListener("scroll", handleScrollModal)
        }
    }, [menuOpen, memberModalVisible, memberModalRef, handleScrollModal, handleScrollWindow])    

    useEffect(() => {
        setShowTopbar(menuOpen === false && modalVisible === false)
    }, [menuOpen, modalVisible])

    useEffect(() => {
        if (currentPage) {
            const classList = document.body.classList;
            classList.forEach(className => {
                if (className.startsWith('mga-section-')) {
                    classList.remove(className);
                }
            });
            classList.add(`mga-section-${currentPage}`);
        }
    }, [currentPage])

    return (
        <AnimatePresence mode="wait">
            {showTopbar && (
                <motion.div
                    key="mga-header-topbar"
                    className={`mga-header__topbar${isFixed ? ' mga-header__topbar--fixed' : ''}`}
                    initial={{ opacity: 0, y: '-100%' }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: '-100%' }}
                    transition={{ duration: 0.5, type: 'tween' }}
                >
                    <div className="mga-header__topbar__wrapper">
                        <HomeLink whitemode={isLight && currentPage !== 'contact'} minimal={showMinimal} />
                        <AnimatePresence mode="wait">
                            { memberModalVisible ?
                                <motion.div
                                    style={{ marginLeft: 'auto' }}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{
                                        opacity: 0,
                                        transition: {
                                            duration: 0.3,
                                            delay: 0,
                                        }
                                    }}
                                    transition={{ duration: 0.5, delay: 0.5, type: 'tween' }}
                                >
                                    <motion.button
                                        className="mga-header__topbar__back"
                                        onClick={handleExit}
                                    >
                                        { strings.back }
                                    </motion.button>
                                </motion.div>
                            : '' }
                        </AnimatePresence>
                        <MenuButton whitemode={isLight} />
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default React.memo(Topbar)